/* eslint-disable camelcase */
import { call, put, takeLatest, select } from 'redux-saga/effects'
import axiosApi from '../../views/client/axiosClient'
import { handleRequest, transferFromCached, transfersFromCached } from '../../lib/common'

import orderConstants, { FormFiels } from './constants'
import * as orderActions from './actions'

const getOrderState = state => state.order;

function* loadThuoc({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.LOAD_THUOC_INFO_API,
      payload
    )

    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request);
    const { code, message, data } = response
    if (code != 200) {
      return yield put(orderActions.setWarning(message))
    }
    if (!data) {
      const warningMsg = 'Thuốc đang hết hàng trong kho, hãy chọn thuốc khác'
      return yield put(orderActions.setWarning(warningMsg))
    }

    yield put(orderActions.setThuoc(data));
    yield put(orderActions.setItem(data));
    yield call(onSuccess, data)
  } catch (error) {
    yield put(orderActions.setWarning(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* loadThuocs({payload, onSuccess}) {
  try {
    const order = yield select(getOrderState);
    const request = axiosApi().post(
      orderConstants.LOAD_THUOCS_API,
      payload
    )
    const response = yield call(handleRequest, request);
    const { data: { records } } = response
    yield put(orderActions.setThuocs(records));
    if (onSuccess) {
      yield call(onSuccess, records)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  }
}

function* loadOrderDetails({payload, callback}) {
  try {
    const request = axiosApi().post(
      orderConstants.LOAD_ORDER_DETAILS_API,
      {
        order_id: payload.orderId,
        mode: payload.mode
      }
    )
    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request);
    if (!response) {
      yield put(orderActions.setError("Lỗi lấy thông tin đơn hàng"))
    }
    const { code, message, data } = response
    if (code != 200) {
      yield put(orderActions.setError(message))
      if (callback && callback.onError) {
        yield call(callback.onError, message)
      }
      return
    }
    yield put(orderActions.setOrderInfor(data));
    if (data.items) {
      const items = data.items.map((item) => {
        return {
          id: item.Id,
          product_id: item.product_id,
          ten: item.ten_hang,
          gia_ban: item.gia_ban || 0,
          dvt: item.dvt,
          so_luong: item.so_luong || 0,
          chiet_khau: item.chiet_khau || 0,
          diem: item.diem,
          thanh_tien: item.thanh_tien,
          sku: item.sku,
          is_km: item.is_km,
          gia_ban_origin: item.gia_ban_origin,
        }
      })

      yield put(orderActions.setItems(items))
      if (callback && callback.onSuccess) {
        yield call(callback.onSuccess, data)
      }
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}
function* loadUsers({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.LOAD_USERS_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request);
    yield put(orderActions.setUsers(response.data));
    yield call(onSuccess, response.data)
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* loadCustomers({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.LOAD_CUSTOMERS_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { records } = yield call(handleRequest, request)
    const items = transfersFromCached(records)
    yield put(orderActions.setCustomers(items))
    yield call(onSuccess, items)
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* loadCustomer({payload, callback}) {
  try {
    const request = axiosApi().post(
      orderConstants.LOAD_CUSTOMER_INFO_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, data } = yield call(handleRequest, request)
    yield put(orderActions.setCustomer(transferFromCached(data)))
    yield put(orderActions.setIsLoading(false))
    if (typeof callback === 'function') {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

// load danh muc kho theo user
function* loadKhos({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.LOAD_KHOS_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request);
    if (response) {
      const { records } = response
      yield put(orderActions.setKhos(records))
      yield call(onSuccess, records)
    } else {
      yield call(onSuccess, [])
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* loadOrderHistory({payload}) {
  try {
    const request = axiosApi().post(
      orderConstants.LOAD_ORDER_HISTORY_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { data } = yield call(handleRequest, request);
    yield put(orderActions.SetOrderHistory(data.records));
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function* loadOrderExport() {
  try {
    const order = yield select(getOrderState);
    const url = `${orderConstants.LOAD_ORDER_EXPORT_API}/${order.formData.order_id}/${order.formData.store_id}`;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    yield put(orderActions.setIsLoading(true));
    const { data } = yield call(handleFileRequest, request);
    yield put(orderActions.SetOrderExport(data));
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}
// xuat ra excel
function* loadOrderExcel({payload, onSuccess}) {
  try {
    const url = `${orderConstants.LOAD_ORDER_EXCEL_API}?order=${payload.orderId}`;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    yield put(orderActions.setIsLoading(true));

    // grab the client from our action
    const results = yield call(handleRequest, request);
    if (results.code && results.code != 200) {
      yield put(orderActions.setError(results.message))
    }
    // callback on success
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, results)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* deleteOrder({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.DELETE_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message, data } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage(message));
      yield call(onSuccess, data)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

// huỷ bỏ đơn hàng chỉ người có quyền mới được tác động
function* cancelOrder({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.CANCEL_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message, data } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage(message));
      yield call(onSuccess, data)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* approveOrder({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.APPROVE_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage("Hoàn thành đơn hàng thành công"));
      yield call(onSuccess)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* processOrder({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.PROCESS_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage("Tiếp nhận đơn hàng thành công"));
      yield call(onSuccess)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* returnOrder({payload}) {
  try {
    const order = yield select(getOrderState);
    const {
      callback,
    } = order
    const request = axiosApi().post(
      orderConstants.RETURN_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage("Trả hàng thành công"));
      yield call(callback)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* revertOrder({payload}) {
  try {
    const order = yield select(getOrderState);
    const {
      callback,
    } = order
    const request = axiosApi().post(
      orderConstants.REVERT_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage("Trả lại đơn hàng thành công"));
      yield call(callback)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}
function* unlockOrder({payload, callback}) {
  try {
    const reqData = {
      id: payload.orderId,
      loai_hd: payload.typeOfOrder,
    }
    const request = axiosApi().post(
      orderConstants.UNLOCK_ORDER_API,
      reqData
    )

    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request)
    if (response.code !== 200) {
      yield put(orderActions.setError(response.message))
    } else {
      yield put(orderActions.setMessage(response.message))
      yield call(callback)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}
function* calcOrder({onSuccess}) {// calcOrder tinh toan cac items tren don
  try {
    const order = yield select(getOrderState)
    const {
      items,
      orderInfor,
    } = order
    const reqData = {
      bo_chiet_khau: orderInfor[FormFiels.BoChietKhau],
      khach_hang_id: orderInfor[FormFiels.KhachHangId],
      items: items,
    }
    const request = axiosApi().post(
      orderConstants.CALC_ORDER_API,
      reqData
    )
    yield put(orderActions.setIsLoading(true));
    const {code, message, data} = yield call(handleRequest, request)
    if (code !== 200) {
      yield put(orderActions.setError(message))
    } else {
      yield call(onSuccess, transferFromCached(data))
    }
  } catch (e) {
    yield put(orderActions.setError(e.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* canPushOrder({payload, onSuccess}) {
  // canPushOrder kiem tra xem he thong co cho dat don khong
  try {
    const request = axiosApi().post(
      orderConstants.CAN_PUSH_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request)
    if (response.code !== 200) {
      yield call(onSuccess, false)
    } else {
      yield call(onSuccess, response.data)
    }
  } catch (e) {
    yield put(orderActions.setError(e.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* saveOrder({callback}) {
  try {
    const order = yield select(getOrderState)
    const {
      items,
      orderInfor,
      typeOfOrder,
    } = order
    const reqData = {
      id: orderInfor[FormFiels.OrderId],
      loai_hd: typeOfOrder,
      kho_xuat_id: orderInfor[FormFiels.KhoXuatId],
      ghi_chu: orderInfor[FormFiels.GhiChu],
      bo_chiet_khau: orderInfor[FormFiels.BoChietKhau],
      ngay_lap: orderInfor[FormFiels.NgayLap],
      ngay_giao: orderInfor[FormFiels.NgayGiao],
      xuat_hoa_don: orderInfor[FormFiels.XuatHoaDon],
      khach_hang_id: orderInfor[FormFiels.KhachHangId],
      nhan_vien_id: orderInfor[FormFiels.NhanVienId],
      kho_nhap_id: orderInfor[FormFiels.KhoNhapId],
      items: items,
    }
    const request = axiosApi().post(
      orderConstants.SAVE_ORDER_API,
      reqData
    )

    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request)
    if (response.code !== 200) {
      yield put(orderActions.setError(response.message))
    } else {
      const {data} = response
      yield put(orderActions.setMessage(response.message))
      yield call(callback, data)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* OrderConfirmMoney({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      orderConstants.SET_ORDER_CONFIRM_MONEY_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message, data } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage(message));
      yield call(onSuccess, data)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* orderWatcher() {
  yield [
    yield takeLatest(orderConstants.LOAD_ORDER_DETAILS, loadOrderDetails),
    yield takeLatest(orderConstants.LOAD_USERS, loadUsers),
    yield takeLatest(orderConstants.LOAD_CUSTOMERS, loadCustomers),
    yield takeLatest(orderConstants.LOAD_CUSTOMER_INFO, loadCustomer),
    yield takeLatest(orderConstants.LOAD_THUOCS, loadThuocs),
    yield takeLatest(orderConstants.LOAD_THUOC_INFO, loadThuoc),
    yield takeLatest(orderConstants.LOAD_KHOS, loadKhos),
    yield takeLatest(orderConstants.LOAD_ORDER_HISTORY, loadOrderHistory),
    yield takeLatest(orderConstants.LOAD_ORDER_EXPORT, loadOrderExport),
    yield takeLatest(orderConstants.LOAD_ORDER_EXCEL, loadOrderExcel),
    yield takeLatest(orderConstants.SAVE_ORDER, saveOrder),
    yield takeLatest(orderConstants.DELETE_ORDER, deleteOrder),
    yield takeLatest(orderConstants.CANCEL_ORDER, cancelOrder),
    yield takeLatest(orderConstants.APPROVE_ORDER, approveOrder),
    yield takeLatest(orderConstants.PROCESS_ORDER, processOrder),
    yield takeLatest(orderConstants.RETURN_ORDER, returnOrder),
    yield takeLatest(orderConstants.REVERT_ORDER, revertOrder),
    yield takeLatest(orderConstants.UNLOCK_ORDER, unlockOrder),
    yield takeLatest(orderConstants.CALC_ORDER, calcOrder),
    yield takeLatest(orderConstants.CAN_PUSH_ORDER, canPushOrder),
    yield takeLatest(orderConstants.SET_ORDER_CONFIRM_MONEY, OrderConfirmMoney),
  ]
}

export default orderWatcher



// WEBPACK FOOTER //
// ./src/views/Order/sagas.js